import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=769cd218&lang=css"

const __exports__ = script;

export default __exports__